module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_tuulonen_sm-fd6f3c25962a8ca9209d5bf7aac648a4.png";